import { render } from "./doctorList.vue?vue&type=template&id=0d4c551b"
import script from "./doctorList.vue?vue&type=script&lang=js"
export * from "./doctorList.vue?vue&type=script&lang=js"

import "./doctorList.vue?vue&type=style&index=0&id=0d4c551b&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__